import * as React from 'react';
import { clsx } from 'clsx';
import IconFontAwesome from "../components/iconFontAwesome";
import type { MenuItemData } from "../rest.interface";

interface MenuItemTitleProps extends React.ComponentPropsWithoutRef<"a"> {
	item: MenuItemData,
	subMenuItems: MenuItemData[],
	depth?: number,
	pathname: string,
}

function getUrlForMenuItem(item: MenuItemData) {
	let toReturn = '';

	switch (item.type) {
		case 'Url':
			toReturn = item?.url;
			break;
		case 'Page':
			toReturn = item?.page?.absoluteUrl;
			break;
	}

	return toReturn;
}

function MenuItemTitle({ item, subMenuItems, pathname, depth = 0, className }: MenuItemTitleProps) {
	const url = getUrlForMenuItem(item);

	const name = <>
		{item.title}
		{subMenuItems.length > 0 && <>
			&nbsp;
			<IconFontAwesome className={clsx(depth === 0 ? "icon-chevron-down" : 'icon-chevron-right', "align-top text-sm text-white")}/>
		</>}
	</>

	return (<>
		{item.type === 'Label' ?
			<span className={className}>{name}</span> :
			<a href={url} className={clsx(pathname === url && "current", className)}>{name}</a>
		}
	</>);
}

export default MenuItemTitle;
